import { HashRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { clearSession, getAccount, getToken } from './lib/api';
import { SignUp } from './pages/SignUp';
import { SignIn } from './pages/SignIn';
import { Devices } from './pages/Devices';
import { RegisterDevice } from './pages/RegisterDevice';
import { DeviceDetail } from './pages/DeviceDetail';
import { DeviceConfig } from './pages/DeviceConfig';
import { Coupons } from './pages/Coupons';
import { Billing } from './pages/Billing';

/** NeteGate Business — wireframes B1–B7. */
function Shell() {
  const account = getAccount();
  if (!getToken() || !account) return <Navigate to="/signin" replace />;

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          Nete<span>Gate</span>
        </div>
        <div className="who">
          {account.businessName}
          {' · '}
          <a
            href="#/signin"
            onClick={() => {
              clearSession();
            }}
          >
            Sign out
          </a>
        </div>
      </header>

      <nav className="tabbar">
        <NavLink to="/devices">Devices</NavLink>
        <NavLink to="/coupons">Coupons</NavLink>
        <NavLink to="/billing">Billing</NavLink>
      </nav>

      <div className="content">
        <Routes>
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/new" element={<RegisterDevice />} />
          <Route path="/devices/:deviceId" element={<DeviceDetail />} />
          <Route path="/devices/:deviceId/config" element={<DeviceConfig />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="*" element={<Navigate to="/devices" replace />} />
        </Routes>
      </div>

      <footer className="qubow-footer muted" style={{ fontSize: '12px', textAlign: 'center', padding: '20px 0', width: '100%' }}>
        © 2026 Developed by <b><a href="https://www.qubow.com" target="_blank" aria-label="Qubow" style={{ color: 'inherit', textDecoration: 'none' }}>Qubow</a></b>
      </footer>
    </div>
  );
}

export function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/*" element={<Shell />} />
      </Routes>
    </HashRouter>
  );
}
